import React from "react";
import Stack from "../ui/Stack";
import avtar from "../../assets/images/avatar.jpg";
import {capitalize} from "../Utility";
import {useSelector} from "react-redux";
import Image from "../common/Image";

const ProfileInfo = () => {
    const {
        user,
        selectedRole: userRole,
    } = useSelector((state) => state.auth);
    return (
        <Stack className="align-items-center flex-column gap-3">
            <div className="profile-image rounded-pill overflow-hidden mb-2 border p-1 w-50 user-select-none">
                <div className="ratio ratio-1x1">
                    {user.image ? <Image src={user.image} alt={user.image} className="rounded-pill object-fit-cover"/> :
                        <img className="rounded-pill" src={avtar} alt="avatar"/>}
                </div>
            </div>
            <h5 className="mb-n2 fw-semibold">{`${capitalize(user.fName)} ${capitalize(user.lName)}`}</h5>
            <p className="fs-sm fw-medium opacity-75">{`${userRole?.scope} ${userRole?.role}`}</p>
            {/* <div>
                <h4 className="fs-sm text-center mb-4">Assigned Tasks</h4>
                <div className="d-flex flex-wrap gap-4">y
                    <div className="border rounded-1 fw-medium pt-2 pb-1 px-4 text-center"><h6
                        className="m-0">243</h6><span
                        className="fs-sm fw-medium opacity-50">Total</span></div>
                    <div className="border rounded-1 fw-medium pt-2 pb-1 px-4 text-center"><h6
                        className="m-0">56</h6><span
                        className="fs-sm fw-medium opacity-50">Solved</span></div>
                    <div className="border rounded-1 fw-medium pt-2 pb-1 px-4 text-center"><h6
                        className="m-0">188</h6><span className="fs-sm fw-medium opacity-50">Open</span>
                    </div>
                </div>
            </div>*/}
        </Stack>
    );
}
export default ProfileInfo;
